import { useRecoilValue } from "recoil"
import { localUserIdAtom, usersSelector } from "../../recoil/atoms/users"
import { hasPermission } from "../../util"
import { useLocalUserType } from "../useLocalUserType"

const UserPermission = window.MeetOnline?.UserPermission

type useLocalUserHasPermissionsReturn = {
  canUseChat: boolean
  canSendChat: boolean
  canSeeHistory: boolean
  canUseMic: boolean
  canUseCam: boolean
  canUseScreenshare: boolean
}

const useLocalUserHasPermissions = (): useLocalUserHasPermissionsReturn => {
  const localUserId = useRecoilValue(localUserIdAtom)
  const localUser = useRecoilValue(usersSelector(localUserId))
  const { isModerator } = useLocalUserType()
  const canUseMic =
    isModerator ||
    hasPermission(localUser?.permissions, UserPermission.canUseMic)

  const canUseCam =
    isModerator ||
    hasPermission(localUser?.permissions, UserPermission.canUseCam)

  const canUseScreenshare =
    isModerator ||
    hasPermission(localUser?.permissions, UserPermission.canUseScreenshare)

  const canSendChat =
    isModerator ||
    hasPermission(localUser?.permissions, UserPermission.canSendChat)

  const canUseChat =
    isModerator ||
    hasPermission(localUser?.permissions, UserPermission.canUseChat)

  const canSeeHistory =
    isModerator ||
    hasPermission(localUser?.permissions, UserPermission.canSeeHistory)

  return {
    canSendChat,
    canSeeHistory,
    canUseChat,
    canUseMic,
    canUseCam,
    canUseScreenshare
  }
}

export default useLocalUserHasPermissions
